<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index">
        <li app-menuitem [item]="item" [index]="i" [root]="true" [isRoles]="isRoles"></li>
    </ng-container>
</ul>
